export const TERMINAL_STATUSES: string[] = ['done', 'failed', 'dead'];
export const FAILED_STATUSES: string[]   = ['failed', 'dead'];
